import addresses from 'config/constants/contracts'
import tokens from 'config/constants/tokens'
import { Address } from 'config/constants/types'
import { ethers } from 'ethers'
import { simpleRpcProvider, simpleWeb3Provider } from './providers'

// eslint-disable-next-line consistent-return
export const getAddress = (address: Address): string => {
  const mainNetChainId = 56
  const chainId = process.env.REACT_APP_CHAIN_ID
  return address[chainId] ? address[chainId] : address[mainNetChainId]
}

export const getContractV2 = (abi: any, address: string, signer?: ethers.Signer | ethers.providers.Provider) => {
  const signerOrProvider = signer ?? simpleWeb3Provider
  return new ethers.Contract(address, abi, signerOrProvider)
}

export const getRouterAddress = () => {
  return getAddress(addresses.router)
}

export const getMulticallAddress = () => {
  return getAddress(addresses.multiCall)
}
export const getWbnbAddress = () => {
  return getAddress(tokens.wbnb.address)
}

export const getPixelAddress = () => {
  return getAddress(addresses.pxfToken)
}

export const getPxpAddress = () => {
  return getAddress(addresses.pxpToken)
}

export const getLotteryAddress = () => {
  return getAddress(addresses.lottery)
}

export const getLimitedAddress = () => {
  return getAddress(addresses.limited)
}

export const getPowerAddress = () => {
  return getAddress(addresses.power)
}

export const getSellerAddress = () => {
  return getAddress(addresses.seller)
}

export const getBUSDAddress = () => {
  return getAddress(addresses.busdToken)
}
export const getUSDTAddress = () => {
  return getAddress(addresses.usdtToken)
}

export const getAirDropAddress = () => {
  return getAddress(addresses.airdrop)
}

export const getNftAddress = () => {
  return getAddress(addresses.nft)
}

export const getNftExchangeAddress = () => {
  return getAddress(addresses.exchange)
}

export const getPxfTokenAddress = () => {
  return getAddress(addresses.pxfToken)
}

export const getPxpTokenAddress = () => {
  return getAddress(addresses.pxpToken)
}

export const getSinglePoolAddress = () => {
  return getAddress(addresses.singlePool)
}

export const getFusionPoolAddress = () => {
  return getAddress(addresses.fusionPool)
}

export const getLotteryTicketAddress = () => {
  return getAddress(addresses.lotteryNFT)
}

export const getPixelFramAddress = () => {
  return getAddress(addresses.pixelFram)
}

export const getStarterAddress = () => {
  return getAddress(addresses.starter)
}
export const getLendingPoolAddress = () => {
  return getAddress(addresses.lendingPool)
}
